import React from 'react';
import { useIsNative } from '~/context/common/DeviceContext';

export default function HideOnNative(props: React.PropsWithChildren<{}>) {
  const isNative = useIsNative();

  return isNative ? null : <>{props.children}</>;
}
